const {Component} = require("react");

class Loader extends Component {

	constructor(props) {
		super(props);

		this.state = {
			active: props.active || false
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.active !== this.state.active) {
			this.setState({active: nextProps.active});
		}
	}

	get className() {
		let classList = ["loader"];

		if (this.state.active) {
			classList.push("active");
		}

		if (this.props.slow === true) {
			classList.push("slow");
		}

		if (this.props.small === true) {
			classList.push("small");
		}

		if (this.props.white === true) {
			classList.push("white");
		}

		return classList.join(" ");
	}

	activate() {
		this.setState({active: true});
		return this;
	}

	deactivate() {
		this.setState({active: false});
		return this;
	}

	get active() {
		return this.state.active;
	}

	render() {
		return (
			<div className={this.className}><div className="flowspinner"></div></div>
		);
	}
}

module.exports = Loader;